export default "__VITE_ASSET__6ab462ac__"